











































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositInstantAccessSettings from "@/models/Products/ProductSettings/DefaultSettings/InstantAccess/DepositInstantAccessSettings";
import DepositInstantAccessSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/InstantAccess/DepositInstantAccessSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositInstantAccessSettingsRead', components: { ProductState, DepositInstantAccessSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositInstantAccessSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }

}
